let Brandfocus_data2_2 =[
    {
        id : 42,
        imgurl : 'img/section5/section5_2_3.jpg',
        brand : 'FITFLOP',
        title : '체인 브라운 여성 쪼리 샌들',
        persent : '14%',
        price : '161,420',
    },
    {
        id : 43,
        imgurl : 'img/section5/section5_2_4.jpg',
        brand : 'FITFLOP',
        title : '레더 크림 여성 플립플랍',
        persent : '10%',
        price : '116,100',
    },
    {
        id : 44,
        imgurl : 'img/section5/section5_2_5.jpg',
        brand : 'FITFLOP',
        title : '레더 진한 네이비 여성 슬라이드',
        persent : '10%',
        price : '170,100',
    },
    {
        id : 45,
        imgurl : 'img/section5/section5_2_6.jpg',
        brand : 'MARIE CLAIRE',
        title : '메쉬 레이어링 스커트',
        persent : '83%',
        price : '31,500',
    },
    {
        id : 46,
        imgurl : 'img/section5/section5_2_7.jpg',
        brand : 'MARIE CLAIRE',
        title : '마리 로고 버튼 니트 가디건',
        persent : '28%',
        price : '71,100',
    },
    {
        id : 47,
        imgurl : 'img/section5/section5_2_8.jpg',
        brand : 'MARIE CLAIRE',
        title : '벨티드 퀼로트 와이드 팬츠',
        persent : '65%',
        price : '62,100',
    },
]

export default Brandfocus_data2_2;